import {
    AfterViewInit,
    Component,
    ElementRef,
    OnDestroy,
    OnInit,
    Renderer2,
    ViewChild,
    ViewContainerRef
} from '@angular/core';
import { select, Store } from '@ngrx/store';
import {
    StateService,
    TransitionPromise,
    TransitionService
} from '@uirouter/core';
import $ from 'jquery';
import { combineLatest, Observable, ReplaySubject } from 'rxjs';
import {
    distinctUntilChanged,
    take,
    takeWhile,
    tap,
    withLatestFrom
} from 'rxjs/operators';
import { AuthenticationService } from './auth/authentication.service';
import * as fromAuth from './auth/store';
import * as fromCompanySetting from './company-setting';
import * as fromLookups from './lookups';
import { IDirectReport } from './lookups';
import { getHasValidTokens } from './quickbooks/store/quickbooks.selectors';
import { ReportingFeatureComponent } from './reporting/features/reporting-feature.component';
import * as fromShared from './shared';
import { IStatusMessage, Process } from './shared';
import {
    MenuItem,
    ScrollPanel
} from './shared/efaact-primeng.module';
import { DialogService } from './shared/modal-dialog/dialog.service';
import { LoggingService } from './shared/services/logging/logging.service';
import * as fromRoot from './store';
import * as fromQuickbooks from './quickbooks/store';
import { ToasterService } from './toaster/service/toaster-service';
import * as fromUser from './user-info';
import { IUserRole } from './user-role/IUserRole';
import * as fromUserRole from './user-role/store/reducers';
import { PrimeNG } from 'primeng/config';
import { target } from 'modernizr';
import { MenuService } from './layout/service/menu.service';
import * as fromUserSetting from './user-setting';

enum MenuOrientation {
    STATIC,
    OVERLAY,
    SLIM,
    HORIZONTAL
}
@Component({
    selector: 'ef-app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit, OnDestroy, AfterViewInit {
    layoutMode: MenuOrientation = MenuOrientation.STATIC;

    darkMenu = true;

    profileMode = 'top';

    rotateMenuButton: boolean;

    topbarMenuActive: boolean;

    overlayMenuActive: boolean;

    staticMenuDesktopInactive = false;

    staticMenuMobileActive = true;

    layoutMenuScroller: HTMLDivElement;

    menuClick: boolean;

    topbarItemClick: boolean;

    activeTopbarItem: any;

    resetMenu: boolean;

    menuHoverActive: boolean;

    @ViewChild('reportsSideNav', { static: true })
    reportsSideNav: ReportingFeatureComponent;
    @ViewChild('layoutMenuScroller', { static: true })
    layoutMenuScrollerViewChild: ScrollPanel;
    private componentActive = true;
    public userRoles$: Observable<Array<IUserRole>>;
    public userRoles: Array<IUserRole>;
    public errors$: Observable<Array<IStatusMessage>>;
    public errors: Array<IStatusMessage>;
    public title = 'eFAACT Central';
    public errorCount = 0;
    public ReportsSideNavVisible = false;
    public ReportsStyle = { width: '75rem', 'max-width': '100vw' };
    public userInfo$: Observable<fromUser.IUserInfo>;
    public user$: Observable<fromUser.IUserAccess>;
    user: fromUser.IUserAccess;
    userInfo: fromUser.IUserInfo;
    private directReports$: Observable<Array<IDirectReport>>;
    private ReportButtonSubject = new ReplaySubject<any>(1);
    private OnShowReportsSubject = new ReplaySubject<any>(1);
    @ViewChild('errorsSidenav', { static: true, read: ElementRef })
    errorsSidenavEl;
    @ViewChild('dialogdiv', { read: ViewContainerRef, static: true }) dialogdiv;
    companyURL: string;
    hasCompanyURL: boolean;
    mySettingsProcess: any;
    private userPM$: Observable<Array<fromShared.Process>>;
    myLogoProcess: fromShared.Process;
    companySettingsProcess: fromShared.Process;
    leaveRequestProcess: fromShared.Process;
    companyCalendarProcess: fromShared.Process;
    DetailSideNavVisible = false;
    MessageSideNavVisible = false;
    messageCount = '';
    eFCheckupProcess: fromShared.Process;
    roleName: string;
    messageBadgeStyle = 'ef-menuitem-badge-off';

    model: MenuItem[];

    isSidenavOpen = false;

    public processes: Process[] = [];
    public processTitles: string[] = [];
    roleDrivenModel: any[] = [];
    showFloatingExpertChat = false;
    /** After first open, keeps ef-chat mounted so close (X) preserves history. */
    floatingExpertChatMounted = false;
    /** When false, the floating Expert launcher (and panel) are not shown. */
    showFloatingExpertLauncher = true;
    /** Floating Expert is only available after sign-in. */
    isUserAuthenticated = false;
    /** Company setting ShowAIHelpButton. */
    companyAIHelpButtonEnabled = false;
    /** User setting UserAIHelpButton. */
    userAIHelpButtonEnabled = false;
    private readonly floatingExpertLauncherHideKey =
        'efaact.hideFloatingExpertLauncher';
    /** Sidebar menu item id for reopening AI after floating launcher dismiss. */
    readonly aiExpertMenuItemId = 'ai-expert';
    /** User-resized dimensions; null uses CSS defaults until first resize. */
    floatingExpertPanelWidthPx: number | null = null;
    floatingExpertPanelHeightPx: number | null = null;
    private readonly floatingExpertPanelMinWidthPx = 288;
    private readonly floatingExpertPanelMinHeightPx = 224;
    private endFloatingExpertPanelResize: (() => void) | null = null;
    constructor(
        private log: LoggingService,
        private dialog: DialogService,
        private rootStore: Store<fromRoot.State>,
        private errorsStore: Store<fromShared.Errors.State>,
        private userStore: Store<fromUser.State>,
        public renderer: Renderer2,
        private authService: AuthenticationService,
        private ss: StateService,
        private transitionService: TransitionService,
        private primengConfig: PrimeNG,
        private toaster: ToasterService,
        private menuService: MenuService
    ) {
        // setTheme('bs4');
        var signInToken = JSON.parse(sessionStorage.getItem('auth')).token;
        if (signInToken == null) {
            this.ss.go('main');
        }
        this.setupObservables();
        this.rootStore.dispatch(new fromRoot.GetVersionAction());
        this.rootStore
            .pipe(
                select(getHasValidTokens),
                tap(hasValidTokens =>
                    this.log.verbose({
                        type: 'AppComponent:ngOnInit:getHasValidTokens',
                        hasValidTokens
                    })
                ),
                take(1)
            )
            .subscribe(hasValidTokens => {
                this.rootStore.dispatch(
                    new fromQuickbooks.HasValidTokens(hasValidTokens)
                );
            });
    }
    ngOnDestroy(): void {
        this.componentActive = false;
        this.stopFloatingExpertPanelResize();
    }
    ngAfterViewInit() {
        const themeTag = document.getElementById('themeTag');
        if (themeTag) {
            themeTag.classList.add('default-theme');
        }
        setTimeout(() => {
            //this.layoutMenuScrollerViewChild.moveBar();
        }, 0);
        setTimeout(() => {
            // this.loaded = true;
            // this.log.verbose({type: 'AppComponent:AfterViewInit', loaded: this.loaded});
            this.setupSubscriptions();
        }, 0);
    }
    setupObservables() {
        this.userInfo$ = this.userStore.pipe(select(fromUser.getUserInfo));
        this.user$ = this.userStore.pipe(select(fromUser.getUser));
        this.userRoles$ = this.userStore.pipe(
            select(fromUserRole.getUserRoles)
        );

        this.userPM$ = this.userStore.pipe(
            select(fromUser.getUserProcessesMain)
        );
        this.directReports$ = this.rootStore.pipe(
            select(fromLookups.getDirectReportsLookup)
        );
    }
    setupSubscriptions() {
        this.userRoles$
            .pipe(takeWhile(() => this.componentActive))
            .subscribe(roles => {
                this.userRoles = roles;
                this.roleName = roles.find(role => role.RoleGroupID == this.userInfo?.DefaultRoleGroupID)?.GroupName;
            });

        this.user$
            .pipe(takeWhile(() => this.componentActive))
            .subscribe(user => {
                this.user = user;
                if (this.user && this.processes.length == 0) {
                    this.user.UserProcessCategories.forEach(cat => {
                        cat.UserProcesses.forEach(process => {
                            this.processes.push(process);
                        });
                    });
                    this.processes.forEach(process => {
                        if (process.ProcessID === 69) {
                            this.leaveRequestProcess = process;
                        }
                        this.processTitles.push(process.ProcessTitle);
                    });
                    this.eFCheckupProcess = this.processes.find(
                        x => x.ProcessID == 145
                    );
                }
            });

        this.userPM$
            .pipe(
                takeWhile(() => this.componentActive),
                distinctUntilChanged()
            )
            .subscribe(userProcessMain => {
                if (userProcessMain) {
                    userProcessMain.forEach(process => {
                        if (process.ProcessID === 75) {
                            this.mySettingsProcess = process;
                        }
                        if (process.ProcessID === 77) {
                            this.myLogoProcess = process;
                        }
                        if (process.ProcessID === 49) {
                            this.companySettingsProcess = process;
                        }
                        if (process.ProcessID === 46) {
                            this.companyCalendarProcess = process;
                        }                        
                    });
                }
            });

        this.userInfo$
            .pipe(
                takeWhile(() => this.componentActive),
                distinctUntilChanged()
            )
            .subscribe(userInfo => {
                this.userInfo = userInfo;
                this.log.verbose({
                    type: 'app.component(userInfo$)',
                    ReportsSideNavVisible: this.ReportsSideNavVisible,
                    userInfo
                });

                this.ReportsSideNavVisible = false;

                if (userInfo.Customcompanyurl !== '') {
                    this.companyURL = userInfo.Customcompanyurl;
                    this.hasCompanyURL = true;
                } else {
                    this.hasCompanyURL = false;
                }                
            });
        this.ReportButtonSubject.pipe(
            takeWhile(() => this.componentActive),
            withLatestFrom(this.userInfo$)
        ).subscribe(([event, userInfo]) => {
            this.log.verbose({
                type: 'app.component(userInfo$, ReportButtonSubject)',
                ReportsSideNavVisible: this.ReportsSideNavVisible,
                userInfo
            });
            if (userInfo.eFC_Beta === true) {
                this.ReportsSideNavVisible = !this.ReportsSideNavVisible;
            }
        });
        this.directReports$
            .pipe(takeWhile(() => this.componentActive))
            .subscribe(r => {
                // if (!(r && r.length)) {
                //     this.ReportsStyle.width = '35rem';
                // } else {
                //     this.ReportsStyle.width = '75rem';
                // }
                this.ReportsStyle.width = '66vw';
                this.ReportsStyle['min-width'] = '66vw';
            });

        this.OnShowReportsSubject.pipe(
            withLatestFrom(this.userInfo$)
        ).subscribe(([event, userInfo]) => {
            this.rootStore.dispatch(
                new fromLookups.LoadDirectReports({
                    user: userInfo,
                    activeOnly: false,
                    MyDRsOnly: false,
                    processId: 76
                })
            );
        });

        combineLatest([this.userInfo$, this.user$])
            .pipe(takeWhile(() => this.componentActive))
            .subscribe(([userInfo, user]) => {
                this.messageCount = '';
                if (userInfo && user) {
                    let processes = [];
                    user.UserProcessCategories.forEach(cat => {
                        cat.UserProcesses.forEach(process => {
                            processes.push(process);
                        });
                    });
                    if (processes.length > 0) {
                        const hasProcess69 = processes.find(p => p.ProcessID === 69) != null;
                        const hasProcess77 = user.UserProcessesMain.find(p => p.ProcessID === 77) != null;

                        if (userInfo.DefaultRoleGroupID === 1) {
                            if (hasProcess69 || hasProcess77) {
                                const menuItems: MenuItem[] = [
                                    {
                                        label: 'Dashboard',
                                        icon: 'pi pi-fw pi-objects-column',
                                        command: event => {
                                            this.onMenuDashboardClick(event);
                                        }
                                        //uiSref: 'dashboard'
                                    },
                                    {
                                        label: 'Home',
                                        icon: 'pi pi-fw pi-home',
                                        command: event => {
                                            this.onMenuHomeClick(event);
                                        }
                                        //uiSref: 'main'
                                    },
                                    {
                                        label: 'Company Calendar',
                                        icon: 'pi pi-fw pi-calendar',
                                        command: event => {
                                            this.onTopbarCompanyCalendarClick(event);
                                            if (this.DetailSideNavVisible == true) {
                                                this.DetailSideNavVisible =
                                                    !this.DetailSideNavVisible;
                                            }
                                            if (this.MessageSideNavVisible == true) {
                                                this.MessageSideNavVisible =
                                                    !this.MessageSideNavVisible;
                                            }
                                        }
                                    },
                                    {
                                        label: 'eFAACT Checkup',
                                        icon: 'pi pi-fw pi-exclamation-triangle',
                                        badge: '',
                                        badgeStyleClass: 'ef-menuitem-checkup-badge-off',
                                        command: event => {
                                            this.onMenuEFCheckupClick(event);
                                            if (this.DetailSideNavVisible == true) {
                                                this.DetailSideNavVisible =
                                                    !this.DetailSideNavVisible;
                                            }
                                            if (this.MessageSideNavVisible == true) {
                                                this.MessageSideNavVisible =
                                                    !this.MessageSideNavVisible;
                                            }
                                        }
                                    },
                                    {
                                        label: 'Messages',
                                        icon: 'pi pi-fw pi-envelope',
                                        badge: '',
                                        badgeStyleClass: 'ef-menuitem-badge-off',
                                        command: event => {
                                            if (this.DetailSideNavVisible == true) {
                                                this.DetailSideNavVisible =
                                                    !this.DetailSideNavVisible;
                                            }
                                            this.MessageSideNavVisible =
                                                !this.MessageSideNavVisible;
                                        }
                                    }
                                ];

                                // Add Leave Request only if process 69 exists
                                if (hasProcess69) {
                                    menuItems.push({
                                        label: 'Leave Request',
                                        icon: 'ef-custom-icon ef-leave-request-icon',
                                        command: event => {
                                            this.onSidebarLeaveRequestClick();
                                            if (this.MessageSideNavVisible == true) {
                                                this.MessageSideNavVisible =
                                                    !this.MessageSideNavVisible;
                                            }
                                            this.DetailSideNavVisible =
                                                !this.DetailSideNavVisible;
                                        }
                                    });
                                }

                                // Add Logo only if process 77 exists
                                if (hasProcess77) {
                                    menuItems.push({
                                        label: 'Logo',
                                        icon: 'pi pi-fw pi-image',
                                        command: event => {
                                            this.onTopbarMyLogoClick(event);
                                            if (this.DetailSideNavVisible == true) {
                                                this.DetailSideNavVisible =
                                                    !this.DetailSideNavVisible;
                                            }
                                            if (this.MessageSideNavVisible == true) {
                                                this.MessageSideNavVisible =
                                                    !this.MessageSideNavVisible;
                                            }
                                        }
                                    });
                                }

                                menuItems.push({
                                    label: 'Company Settings',
                                    icon: 'pi pi-fw pi-cog',
                                    command: event => {
                                        this.onSidebarCompanySettingsClick();
                                        if (this.MessageSideNavVisible == true) {
                                            this.MessageSideNavVisible =
                                                !this.MessageSideNavVisible;
                                        }
                                        this.DetailSideNavVisible =
                                            !this.DetailSideNavVisible;
                                    }
                                });

                                this.setRoleDrivenModel(menuItems);
                            } else {
                                this.setRoleDrivenModel([
                                    {
                                        label: 'Dashboard',
                                        icon: 'pi pi-fw pi-objects-column',
                                        command: event => {
                                            this.onMenuDashboardClick(event);
                                        }
                                        //uiSref: 'dashboard'
                                    },
                                    {
                                        label: 'Home',
                                        icon: 'pi pi-fw pi-home',
                                        command: event => {
                                            this.onMenuHomeClick(event);
                                        }
                                        //uiSref: 'main'
                                    },
                                    {
                                        label: 'Company Calendar',
                                        icon: 'pi pi-fw pi-calendar',
                                        command: event => {
                                            this.onTopbarCompanyCalendarClick(event);
                                            if (this.DetailSideNavVisible == true) {
                                                this.DetailSideNavVisible =
                                                    !this.DetailSideNavVisible;
                                            }
                                            if (this.MessageSideNavVisible == true) {
                                                this.MessageSideNavVisible =
                                                    !this.MessageSideNavVisible;
                                            }
                                        }
                                    },
                                    {
                                        label: 'eFAACT Checkup',
                                        icon: 'pi pi-fw pi-exclamation-triangle',
                                        badge: '',
                                        badgeStyleClass: 'ef-menuitem-checkup-badge-off',
                                        command: event => {
                                            this.onMenuEFCheckupClick(event);
                                            if (this.DetailSideNavVisible == true) {
                                                this.DetailSideNavVisible =
                                                    !this.DetailSideNavVisible;
                                            }
                                            if (this.MessageSideNavVisible == true) {
                                                this.MessageSideNavVisible =
                                                    !this.MessageSideNavVisible;
                                            }
                                        }
                                    },
                                    {
                                        label: 'Messages',
                                        icon: 'pi pi-fw pi-envelope',
                                        badge: '',
                                        badgeStyleClass: 'ef-menuitem-badge-off',
                                        command: event => {
                                            if (this.DetailSideNavVisible == true) {
                                                this.DetailSideNavVisible =
                                                    !this.DetailSideNavVisible;
                                            }
                                            this.MessageSideNavVisible =
                                                !this.MessageSideNavVisible;
                                        }
                                    },
                                    {
                                        label: 'Company Settings',
                                        icon: 'pi pi-fw pi-cog',
                                        command: event => {
                                            this.onSidebarCompanySettingsClick();
                                            if (this.MessageSideNavVisible == true) {
                                                this.MessageSideNavVisible =
                                                    !this.MessageSideNavVisible;
                                            }
                                            this.DetailSideNavVisible =
                                                !this.DetailSideNavVisible;
                                        }
                                    }
                                ]);
                            }
                        } else {
                            if (processes.find(p => p.ProcessID == 69) != null) {
                                this.setRoleDrivenModel([
                                    {
                                        label: 'Dashboard',
                                        icon: 'pi pi-fw pi-objects-column',
                                        command: event => {
                                            this.onMenuDashboardClick(event);
                                        }
                                        //uiSref: 'dashboard'
                                    },
                                    {
                                        label: 'Home',
                                        icon: 'pi pi-fw pi-home',
                                        command: event => {
                                            this.onMenuHomeClick(event);
                                        }
                                        //uiSref: 'main'
                                    },
                                    {
                                        label: 'Company Calendar',
                                        icon: 'pi pi-fw pi-calendar',
                                        command: event => {
                                            this.onTopbarCompanyCalendarClick(event);
                                            if (this.DetailSideNavVisible == true) {
                                                this.DetailSideNavVisible =
                                                    !this.DetailSideNavVisible;
                                            }
                                            if (this.MessageSideNavVisible == true) {
                                                this.MessageSideNavVisible =
                                                    !this.MessageSideNavVisible;
                                            }
                                        }
                                    },
                                    {
                                        label: 'Messages',
                                        icon: 'pi pi-fw pi-envelope',
                                        badge: '',
                                        badgeStyleClass: 'ef-menuitem-badge-off',
                                        command: event => {
                                            if (this.DetailSideNavVisible == true) {
                                                this.DetailSideNavVisible =
                                                    !this.DetailSideNavVisible;
                                            }
                                            this.MessageSideNavVisible =
                                                !this.MessageSideNavVisible;
                                        }
                                    },
                                    {
                                        label: 'Leave Request',
                                        icon: 'ef-custom-icon ef-leave-request-icon',
                                        command: event => {
                                            this.onSidebarLeaveRequestClick();
                                            if (this.MessageSideNavVisible == true) {
                                                this.MessageSideNavVisible =
                                                    !this.MessageSideNavVisible;
                                            }
                                            this.DetailSideNavVisible =
                                                !this.DetailSideNavVisible;
                                        }
                                    }
                                ]);
                            } else {
                                this.setRoleDrivenModel([
                                    {
                                        label: 'Dashboard',
                                        icon: 'pi pi-fw pi-objects-column',
                                        command: event => {
                                            this.onMenuDashboardClick(event);
                                        }
                                        //uiSref: 'dashboard'
                                    },
                                    {
                                        label: 'Home',
                                        icon: 'pi pi-fw pi-home',
                                        command: event => {
                                            this.onMenuHomeClick(event);
                                        }
                                        //uiSref: 'main'
                                    },
                                    {
                                        label: 'Company Calendar',
                                        icon: 'pi pi-fw pi-calendar',
                                        command: event => {
                                            this.onTopbarCompanyCalendarClick(event);
                                            if (this.DetailSideNavVisible == true) {
                                                this.DetailSideNavVisible =
                                                    !this.DetailSideNavVisible;
                                            }
                                            if (this.MessageSideNavVisible == true) {
                                                this.MessageSideNavVisible =
                                                    !this.MessageSideNavVisible;
                                            }
                                        }
                                    },
                                    {
                                        label: 'Messages',
                                        icon: 'pi pi-fw pi-envelope',
                                        badge: '',
                                        badgeStyleClass: 'ef-menuitem-badge-off',
                                        command: event => {
                                            if (this.DetailSideNavVisible == true) {
                                                this.DetailSideNavVisible =
                                                    !this.DetailSideNavVisible;
                                            }
                                            this.MessageSideNavVisible =
                                                !this.MessageSideNavVisible;
                                        }
                                    }
                                ]);
                            }
                        }
                    }
                }
            });
    }
    ngOnInit() {
        //this.primengConfig.ripple = true;
        this.dialog.vcRef = this.dialogdiv;

        this.rootStore
            .pipe(
                select(fromAuth.getAuthToken),
                distinctUntilChanged(),
                takeWhile(() => this.componentActive)
            )
            .subscribe(token => {
                this.isUserAuthenticated = !!token;
                if (!token) {
                    this.hideFloatingExpertUi();
                    this.userAIHelpButtonEnabled = false;
                } else {
                    this.rootStore.dispatch(
                        fromCompanySetting.getCompanySetting({
                            SettingType:
                                fromCompanySetting.CompanySettingEnum
                                    .ShowAIHelpButton
                        })
                    );
                }
                this.syncAiExpertMenuItem();
            });

        this.rootStore
            .pipe(
                select(
                    fromCompanySetting.getSettingBooleanValue(
                        fromCompanySetting.CompanySettingEnum.ShowAIHelpButton
                    )
                ),
                distinctUntilChanged(),
                takeWhile(() => this.componentActive)
            )
            .subscribe(enabled => {
                this.companyAIHelpButtonEnabled = enabled;
                if (!this.showAIHelpButton) {
                    this.hideFloatingExpertUi();
                }
                this.syncAiExpertMenuItem();
            });

        this.rootStore
            .pipe(
                select(
                    fromUserSetting.getSettingBooleanValue(
                        fromUserSetting.UserSettingEmpSettingType
                            .UserAIHelpButton
                    )
                ),
                distinctUntilChanged(),
                takeWhile(() => this.componentActive)
            )
            .subscribe(enabled => {
                this.userAIHelpButtonEnabled = enabled;
                if (!this.showAIHelpButton) {
                    this.hideFloatingExpertUi();
                }
                this.syncAiExpertMenuItem();
            });

        try {
            if (
                typeof localStorage !== 'undefined' &&
                localStorage.getItem(this.floatingExpertLauncherHideKey) === '1'
            ) {
                this.showFloatingExpertLauncher = false;
            }
        } catch {
            /* private / restricted storage */
        }
        this.syncAiExpertMenuItem();

        this.errors$ = this.errorsStore.pipe(
            select(fromShared.Errors.getErrors)
        );

        this.errors$
            .pipe(takeWhile(_ => this.componentActive))
            .subscribe(errors => {
                this.errors = errors;
                this.errorCount = this.errors.length;
            });

        this.errorsStore
            .pipe(
                select(fromShared.Errors.getShowErrors),
                takeWhile(() => this.componentActive)
            )
            .subscribe(e => {
                this.log.verbose({
                    type: 'AppComponent:ngAfterViewInit:getShowErrors',
                    e
                });
                if (e.open === true) {
                    this.activeTopbarItem = $('#efErrorsSideNav')[0];
                    this.onTopbarItemClick(null, this.activeTopbarItem);
                } else {
                }
            });
    }
    clearToast() {
        this.toaster.clear('ef-global-toast');
    }
    openUserManual() {
        if (this.companyURL !== '') {
            window.open(this.companyURL, '_blank');
        }
    }
    messageNavClick() {
        this.errorsStore.dispatch(
            new fromShared.Errors.SetShowErrors({
                open: !this.errorsSidenavEl.open,
                MsgEntityID: '',
                MsgProcessID: 0
            })
        );
    }
    onLayoutClick() {
        if (!this.topbarItemClick) {
            this.activeTopbarItem = null;
            this.topbarMenuActive = false;
        }
        if (!this.menuClick) {
            if (this.isHorizontal() || this.isSlim()) {
                this.resetMenu = true;
            }
            if (this.overlayMenuActive || this.staticMenuMobileActive) {
                this.hideOverlayMenu();
            }
            this.menuHoverActive = false;
        }
        this.topbarItemClick = false;
        this.menuClick = false;
    }
    onMenuButtonClick(event) {
        this.menuClick = true;
        this.rotateMenuButton = !this.rotateMenuButton;
        this.topbarMenuActive = false;

        if (this.layoutMode === MenuOrientation.OVERLAY) {
            this.overlayMenuActive = !this.overlayMenuActive;
        } else {
            if (this.isDesktop()) {
                this.staticMenuDesktopInactive =
                    !this.staticMenuDesktopInactive;
            } else {
                this.staticMenuMobileActive = !this.staticMenuMobileActive;
            }
        }
        event.preventDefault();
    }
    onReportButtonClick(event) {
        this.log.verbose({ type: 'app.onReportButtonClick', event });
        event.preventDefault();
        this.ReportButtonSubject.next(event);
    }
    onMenuClick($event) {
        this.menuClick = true;
        this.resetMenu = false;

        if (!this.isHorizontal()) {
            setTimeout(() => {
                //this.layoutMenuScrollerViewChild.moveBar();
            }, 450);
        }
    }
    onTopbarMenuButtonClick(event) {
        this.topbarItemClick = true;
        this.topbarMenuActive = !this.topbarMenuActive;

        this.hideOverlayMenu();

        event.preventDefault();
    }
    onTopbarItemClick(event, item, name?) {
        this.isSidenavOpen = true;
        this.topbarItemClick = true;
        if (!event) {
            this.activeTopbarItem = item;
            return;
        }
        if (this.activeTopbarItem === item) {
            this.activeTopbarItem = null;
            if (name != null) {
                if (name == 'errors') {
                    if (this.errorCount == 0) {
                        this.goto(this.eFCheckupProcess);
                    }
                }
            }
        } else {
            this.activeTopbarItem = item;
        }
        event.preventDefault();
    }
    onTopbarSubItemClick(event) {
        if (event) {
            event.preventDefault();
        }
    }
    onProfileMySettingsClick() {
        this.goto(this.mySettingsProcess);
    }
    onTopbarMySettingsClick(event) {
        if (event) {
            event.preventDefault();
        }
        this.goto(this.mySettingsProcess);
    }
    onProcessClick(process: Process) {
        this.goto(process);
    }
    onTopbarMyLogoClick(event) {
        
        this.goto(this.myLogoProcess);
    }
    onDashboardButtonClick(event) {
        if (event) {
            event.preventDefault();
        }
        this.goto({
            ProcessID: -3,
            ProcessName: 'Dashboard',
            RouteName: 'dashboard',
            ProcessDesc: '',
            ProcessTitle: 'Dashboard'
        });
    }
    onSidebarCompanySettingsClick() {
        this.goto(this.companySettingsProcess);
    }
    onSidebarLeaveRequestClick() {
        this.goto(this.leaveRequestProcess);
    }
    onTopbarCompanySettingsClick(event) {
        if (event) {
            event.preventDefault();
        }
        this.goto(this.companySettingsProcess);
    }
    onTopbarCompanyCalendarClick(event) {
        // if (event) {
        //     event.preventDefault();
        // }
        this.goto(this.companyCalendarProcess);
    }
    onChangePasswordClick(event) {
        // if (event) {
        //     event.preventDefault();
        // }
        const passwordChangeProcess: Process = {
            ProcessID: -13,
            ProcessName: 'Password Change',
            RouteName: 'passwordchange',
            ProcessDesc: 'Password Change',
            ProcessTitle: 'Password Change'
        };
        this.goto(passwordChangeProcess);
    }
    onMenuDashboardClick(event) {
        // if (event) {
        //     event.preventDefault();
        // }
        const dashboardProcess = {
            ProcessID: -3,
            ProcessName: 'Dashboard',
            RouteName: 'dashboard',
            ProcessDesc: '',
            ProcessTitle: '',
            MsgCount: null
        };
        this.goto(dashboardProcess);
    }
    onMenuHomeClick(event) {
        // if (event) {
        //     event.preventDefault();
        // }
        const homeProcess = {
            ProcessID: 0,
            ProcessName: 'Main',
            RouteName: 'main',
            ProcessDesc: '',
            ProcessTitle: '',
            MsgCount: null
        };
        this.goto(homeProcess);
    }
    onMenuEFCheckupClick(event) {
        this.goto(this.eFCheckupProcess);
    }
    public goto(process: Process): TransitionPromise {
        this.log.debug({ type: 'AppComponent:goto', process });
        this.rootStore.dispatch(fromShared.clearProcess());
        this.rootStore.dispatch(fromShared.upsertProcess({ process }));
        if (process.RouteName == 'efaactstore') {
            return this.ss.go('efaactstore', {
                process: { ...process }
            });
        } else {
            return this.ss.go(
                process.RouteName?.toLowerCase().replace('/', '.') as string,
                {
                    process: { ...process }
                }
            );
        }      
    }
    hideOverlayMenu() {
        this.rotateMenuButton = false;
        this.overlayMenuActive = false;
        this.staticMenuMobileActive = false;
    }
    isTablet() {
        const width = window.innerWidth;
        return width <= 1024 && width > 640;
    }
    isDesktop() {
        return window.innerWidth > 1024;
    }
    isMobile() {
        return window.innerWidth <= 640;
    }
    isOverlay() {
        return this.layoutMode === MenuOrientation.OVERLAY;
    }
    isHorizontal() {
        return this.layoutMode === MenuOrientation.HORIZONTAL;
    }
    isSlim() {
        return this.layoutMode === MenuOrientation.SLIM;
    }
    changeToStaticMenu() {
        this.layoutMode = MenuOrientation.STATIC;
    }
    changeToOverlayMenu() {
        this.layoutMode = MenuOrientation.OVERLAY;
    }
    changeToHorizontalMenu() {
        this.layoutMode = MenuOrientation.HORIZONTAL;
    }
    changeToSlimMenu() {
        this.layoutMode = MenuOrientation.SLIM;
    }
    onSignout(event?: Event) {
        if (event) {
            event.preventDefault();
        }
        this.processes = [];
        this.processTitles = [];
        sessionStorage.setItem('IsSignout', 'true');
        sessionStorage.setItem('initialLoadForMainMsg', 'false');
        const homeProcess = {
            ProcessID: 0,
            ProcessName: 'Main',
            RouteName: 'main',
            ProcessDesc: '',
            ProcessTitle: '',
            MsgCount: null
        };
        // Wait for navigation (including timecard unsaved guard) before clearing auth.
        this.goto(homeProcess)
            .then(() => {
                this.authService.logout();
            })
            .catch(() => {
                // Canceled (e.g. user chose Stay on timecard) or superseded transition.
            });
        this.showFloatingExpertChat = false;
        this.floatingExpertChatMounted = false;
        try {
            localStorage.removeItem(this.floatingExpertLauncherHideKey);
        } catch {
            /* ignore */
        }
        this.showFloatingExpertLauncher = true;
        this.syncAiExpertMenuItem();
    }
    dismissFloatingExpertLauncher(event: Event) {
        event.preventDefault();
        event.stopPropagation();
        try {
            localStorage.setItem(this.floatingExpertLauncherHideKey, '1');
        } catch {
            /* ignore */
        }
        this.showFloatingExpertLauncher = false;
        this.showFloatingExpertChat = false;
        this.floatingExpertChatMounted = false;
        this.syncAiExpertMenuItem();
    }
    openFloatingExpertChat(event?: Event) {
        if (!this.showAIHelpButton || !this.showFloatingExpertLauncher) {
            return;
        }
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        this.floatingExpertChatMounted = true;
        this.showFloatingExpertChat = true;
    }
    /** Opens chat from the sidebar when the floating launcher was dismissed via ×. */
    openFloatingExpertChatFromSidebar(event?: Event) {
        if (!this.showAIHelpButton || !this.isUserAuthenticated) {
            return;
        }
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        // Restore floating so it returns when the chat panel is closed.
        this.restoreFloatingExpertLauncher();
        this.floatingExpertChatMounted = true;
        this.showFloatingExpertChat = true;
    }
    closeFloatingExpertChat() {
        this.showFloatingExpertChat = false;
        if (this.showAIHelpButton && this.isUserAuthenticated) {
            this.restoreFloatingExpertLauncher();
        }
    }
    get floatingExpertPanelSizeStyle(): Record<string, string> | null {
        if (this.floatingExpertPanelWidthPx == null) {
            return null;
        }
        return {
            width: `${this.floatingExpertPanelWidthPx}px`,
            height: `${this.floatingExpertPanelHeightPx}px`
        };
    }
    onFloatingExpertPanelResizeStart(
        event: PointerEvent,
        corner: 'nw' | 'ne' | 'sw' | 'se'
    ): void {
        event.preventDefault();
        event.stopPropagation();
        const panel = (event.currentTarget as HTMLElement).closest(
            '.floating-expert-panel'
        ) as HTMLElement | null;
        if (!panel) {
            return;
        }
        this.stopFloatingExpertPanelResize();
        const rect = panel.getBoundingClientRect();
        const startX = event.clientX;
        const startY = event.clientY;
        const startW = rect.width;
        const startH = rect.height;
        const { maxWidth, maxHeight } = this.getFloatingExpertPanelMaxSize();
        const cursor = this.floatingExpertPanelResizeCornerCursor(corner);
        const onMove = (e: PointerEvent) => {
            const dx = e.clientX - startX;
            const dy = e.clientY - startY;
            let w = startW;
            let h = startH;
            switch (corner) {
                case 'se':
                    w = startW + dx;
                    h = startH + dy;
                    break;
                case 'sw':
                    w = startW - dx;
                    h = startH + dy;
                    break;
                case 'ne':
                    w = startW + dx;
                    h = startH - dy;
                    break;
                case 'nw':
                    w = startW - dx;
                    h = startH - dy;
                    break;
            }
            this.floatingExpertPanelWidthPx = Math.min(
                maxWidth,
                Math.max(
                    this.floatingExpertPanelMinWidthPx,
                    Math.round(w)
                )
            );
            this.floatingExpertPanelHeightPx = Math.min(
                maxHeight,
                Math.max(
                    this.floatingExpertPanelMinHeightPx,
                    Math.round(h)
                )
            );
        };
        const onEnd = () => {
            document.removeEventListener('pointermove', onMove);
            document.removeEventListener('pointerup', onEnd);
            document.removeEventListener('pointercancel', onEnd);
            document.body.style.removeProperty('user-select');
            document.body.style.removeProperty('cursor');
            this.endFloatingExpertPanelResize = null;
        };
        document.addEventListener('pointermove', onMove);
        document.addEventListener('pointerup', onEnd);
        document.addEventListener('pointercancel', onEnd);
        document.body.style.userSelect = 'none';
        document.body.style.cursor = cursor;
        this.endFloatingExpertPanelResize = onEnd;
        onMove(event);
    }
    private stopFloatingExpertPanelResize(): void {
        if (this.endFloatingExpertPanelResize) {
            this.endFloatingExpertPanelResize();
        }
    }
    private getFloatingExpertPanelMaxSize(): {
        maxWidth: number;
        maxHeight: number;
    } {
        const rootFontSize =
            parseFloat(
                getComputedStyle(document.documentElement).fontSize
            ) || 16;
        const insetRight = 2.5 * rootFontSize;
        const insetBottom = 5.3 * rootFontSize;
        const insetTop = 1.5 * rootFontSize;
        return {
            maxWidth: window.innerWidth - insetRight * 2,
            maxHeight: window.innerHeight - insetBottom - insetTop
        };
    }
    private floatingExpertPanelResizeCornerCursor(
        corner: 'nw' | 'ne' | 'sw' | 'se'
    ): string {
        return corner === 'se' || corner === 'nw'
            ? 'nwse-resize'
            : 'nesw-resize';
    }
    private hideFloatingExpertUi(): void {
        this.showFloatingExpertChat = false;
        this.floatingExpertChatMounted = false;
    }
    /**
     * AI controls require both company ShowAIHelpButton and user UserAIHelpButton.
     */
    get showAIHelpButton(): boolean {
        return (
            this.companyAIHelpButtonEnabled && this.userAIHelpButtonEnabled
        );
    }
    /** True when AI is enabled and the floating launcher was dismissed via ×. */
    get showAiExpertSidebarButton(): boolean {
        return (
            this.isUserAuthenticated &&
            this.showAIHelpButton &&
            !this.showFloatingExpertLauncher
        );
    }
    private createAiExpertMenuItem(): MenuItem {
        return {
            id: this.aiExpertMenuItemId,
            label: 'Ask eFAACT',
            icon: 'pi pi-sparkles',
            class: 'ai-expert-menuitem',
            visible: this.showAiExpertSidebarButton,
            command: event => {
                this.openFloatingExpertChatFromSidebar(
                    event?.originalEvent as Event
                );
            }
        };
    }
    private withAiExpertMenuItem(items: any[]): any[] {
        const list = (items || []).filter(
            i => i?.id !== this.aiExpertMenuItemId
        );
        if (list.length === 0) {
            return list;
        }
        return [...list, this.createAiExpertMenuItem()];
    }
    private setRoleDrivenModel(items: any[]): void {
        this.roleDrivenModel = this.withAiExpertMenuItem(items);
        this.menuService.triggerMenuUpdate();
    }
    private syncAiExpertMenuItem(): void {
        if (this.roleDrivenModel?.length) {
            this.roleDrivenModel = this.withAiExpertMenuItem(
                this.roleDrivenModel
            );
        }
        this.menuService.triggerMenuUpdate();
    }
    private restoreFloatingExpertLauncher(): void {
        try {
            localStorage.removeItem(this.floatingExpertLauncherHideKey);
        } catch {
            /* ignore */
        }
        this.showFloatingExpertLauncher = true;
        this.syncAiExpertMenuItem();
    }
    onReportsSideNavHide() {
        this.reportsSideNav.clear();
    }
    onReportsSideNavShow() {
        this.OnShowReportsSubject.next();
    }
}
